import React from "react";
import { NikoPatientInsurancePreviewTemplate } from "themes/application/niko-patient/components";
import { NikoPatientInsurancePreviewViewStore } from 'application/niko-patient/stores';
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new NikoPatientInsurancePreviewViewStore(rootStore, componentProps), 'nikoPatientInsurancePreviewViewStore')
@observer
class NikoPatientInsurancePreview extends React.Component {
	render() {
		return <NikoPatientInsurancePreviewTemplate {...this.props} />;
	}
}

export default NikoPatientInsurancePreview;